import { registerGroup, registerRect, registerRichtext, registerSymbol, registerText } from '@visactor/vrender-kits';

export function loadTooltipComponent() {
  registerGroup();
  registerRect();
  registerSymbol();
  registerText();
  registerRichtext();
}
